import { render } from "./PlaySoundPropsCmp.vue?vue&type=template&id=5db45d0e"
import script from "./PlaySoundPropsCmp.vue?vue&type=script&lang=js"
export * from "./PlaySoundPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__